module.exports = __webpack_public_path__ + "img/13.98faab8f.jpg";